import { IStateRejected, IStepState, IStepStateFulfilled } from '../../interfaces';
import { stepAction } from '../actions';

const findAllStepWithForm = () => {
  const { pending, fulfilled, rejected } = stepAction.findAllStepWithForm;
  return {
    // Pending
    [pending.type]: (state: IStepState): IStepState => ({
      ...state,
      status: 'loading',
      error: '',
    }),
    // Fulfilled
    [fulfilled.type]: (_: IStepState, action: IStepStateFulfilled): IStepState => ({
      status: 'success',
      steps: action.payload,
      error: '',
    }),
    // Rejected
    [rejected.type]: (_: IStepState, action: IStateRejected): IStepState => ({
      steps: [],
      status: 'error',
      error: action.error.message,
    }),
  };
};

export default {
  ...findAllStepWithForm(),
};
